export default function($el) {
  $el.kendoPanelBar({
    expandMode: 'multiple'
  });
}
